Ext.ns('mx.data');

mx.data.State = mx.data.Record.create(
    [{name: 'id', type: 'string'}, {name: 'name', type: 'string'}, {name: 'country', type: 'mx.data.Country'}],
    MXAT.API('states/')
);
